import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { ButtonReset, zIndex } from '@helpers/global';
import { Device, from, until } from '@helpers/media';
import { ButtonElement } from '@stories/Elements/Forms/Button/Button.styles';
import styled from 'styled-components';
const Container = styled.section `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: ${zIndex.modal};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
`;
const Modal = styled.div `
  background: ${brand.white};
  padding: ${fluid(20, 30)} ${fluid(20, 24)};
  text-align: center;
  max-width: 725px;
  font-size: 16px;
  max-height: 80vh;
  overflow-y: auto;
  position: relative;
  margin-bottom: 15vw;

  @media ${until(Device.MobileLarge)} {
    justify-content: center;
    margin-bottom: 0px;
  }
`;
const ModalInner = styled.div `
  display: flex;
  flex-direction: column;
`;
const Title = styled.p `
  margin-bottom: 12px;
  line-height: 1.4;
  font-size: 20px;
  font-weight: bold;

  @media ${until(Device.Tablet)} {
    padding-right: 15px;
  }
`;
const Description = styled.p `
  line-height: 1.5;
  font-size: 16px;

  a {
    color: ${brand.nearlyBlack};
    text-decoration: underline;
  }

  + p {
    margin-top: 12px;
  }
`;
const Buttons = styled.div `
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: center;
  margin-top: 20px;
  flex-wrap: wrap;

  @media ${from(Device.Tablet)} {
    [data-buttons='3'] & {
      flex-wrap: nowrap;

      ${ButtonElement}:first-child {
        margin-right: 50px;
      }
    }
  }

  @media ${until(Device.MobileLarge)} {
    ${ButtonElement} {
      width: 100%;
    }
  }
`;
const ReadMore = styled.button.attrs({ type: 'button' }) `
  font-size: 14px;
  ${fonts.lato.bold};
  outline: none;
  border: none;
  background: none;
  padding: 0px;
  position: relative;
  z-index: 3;
  margin-top: 8px;
  user-select: none;
`;
const Close = styled.button.attrs({ type: 'button' }) `
  ${ButtonReset};
  position: absolute;
  top: 20px;
  right: 20px;
  transform: translate(50%, -50%);
  width: 16px;
  height: 16px;

  @media ${from(Device.Tablet)} {
    width: 20px;
    height: 20px;
  }
`;
const CookiePopupStyles = {
    Container,
    Modal,
    ModalInner,
    Title,
    Description,
    Buttons,
    ReadMore,
    Close,
};
export default CookiePopupStyles;
